import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import Axios from '@/lib/axios-instance';

type APIPayload = {
  order_tracking_status?: boolean;
  order_format_example?: string;
  is_forward_email?: boolean;
  forward_email_address?: string;
  forward_email_auto_reply_text?: string;
};

type ResponseType = {
  data: any;
  meta: any;
};

export const AddConfigSettings = async (payload: APIPayload) => {
  try {
    const response = await Axios.post(`/chat_widget_settings/config`, payload);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useAddConfigSettings = () => {
  const queryClient = useQueryClient();
  return useMutation<ResponseType, Error, APIPayload>({
    mutationFn: (payload) => AddConfigSettings(payload),
    onSuccess: (data) => {
      toast.success('Lead Settings Updated Successfully');
      queryClient.invalidateQueries({ queryKey: ['get_widget_settings'] });
      console.log(data);
    },
    onError: (error) => {
      toast.error('Lead Settings Update Failed', {
        description: error.message,
      });
    },
  });
};
